import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Picture } from "~/components-shared";
import { useDispatch } from "react-redux";
import onboardingActionCreators from "~/store/onboarding/actions";
import Markdown from "~/components/Markdown";
import instructionManual from "~/assets/i/illustrations/instruction_manual.svg";
import styled from "styled-components";
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const OnboardingTopicsBegin = _ref => {
  let {
    onSuccess
  } = _ref;
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const onSkip = () => {
    dispatch(onboardingActionCreators.companyTopicsSkipStarted());
  };
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Picture, {
    src: instructionManual,
    width: "360px",
    height: "150px",
    backgroundSize: "contain",
    s: {
      my: 8
    }
  }), /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    align: "center",
    text: t("OnboardingTopicsBegin.intro"),
    s: {
      mb: 7
    }
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: onSuccess,
    color: "primary",
    maxWidth: "360px",
    s: {
      mb: 4
    },
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "plus",
    s: {
      mr: 2,
      mt: -0.5
    }
  }), t("OnboardingTopicsBegin.createTopic")), /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    maxWidth: "320px",
    onClick: onSkip,
    fullWidth: true,
    s: {
      mb: 3
    }
  }, t("OnboardingTopicsBegin.skip")));
};
export default OnboardingTopicsBegin;